import { render } from "./identify.vue?vue&type=template&id=14276884&scoped=true"
import script from "./identify.vue?vue&type=script&lang=js"
export * from "./identify.vue?vue&type=script&lang=js"

import "./identify.vue?vue&type=style&index=0&id=14276884&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14276884"]])

export default __exports__